import React from 'react';

import { FeedbackProvider } from './feedback';
import { LoadingDialogProvider } from './backdrop';

const HookProvider: React.FC = ({ children }) => (
  <LoadingDialogProvider>
    <FeedbackProvider>{children}</FeedbackProvider>
  </LoadingDialogProvider>
);

export default HookProvider;
